export default {
  properties: {
    default: { type: 'string' },
    allow_input: { type: 'boolean' },
    enable_alpha: { type: 'boolean' },
  },
};
